import React from "react";
import { Navigate } from "react-router-dom";
import { selectMemberExperienceData } from "../../features/authentication/authenticationSlice";
import { useAppSelector } from "../../hooks/hooks";

const variantAccess =
  (allowedVariants: string[], redirectPath = "/") =>
  <P extends {}>(Component: React.ComponentType<P>) => {
    const VariantAccess: React.FC<P> = props => {
      const memberExperience = useAppSelector(selectMemberExperienceData);
      const variant = memberExperience?.variant;

      if (!variant || !allowedVariants.includes(variant)) {
        return <Navigate to={redirectPath} replace />;
      }

      return <Component {...props} />;
    };

    return VariantAccess;
  };

export default variantAccess;
